import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationResidentialCareCenter: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3944_10767"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3944_10767)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M180.859 197.207V124c13.873-4.917 24.448-7.331 35.271-7.338 10.855-.007 22.11 2.406 37.344 7.377v73.168h-72.615zM180.859 203.334h18.702l-5.855 19.03a6.57 6.57 0 01-12.847-1.932v-17.098zM253.474 203.334h-18.702l5.855 19.03a6.57 6.57 0 0012.847-1.932v-17.098z"
        ></path>
        <rect
          width="13.026"
          height="89.641"
          x="176.603"
          y="111.82"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="6.513"
        ></rect>
        <rect
          width="13.026"
          height="89.641"
          x="244.705"
          y="111.82"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="6.513"
        ></rect>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M168.895 180.185c-6.519-7.643-1.088-19.415 8.959-19.415 6.503 0 11.774 5.271 11.774 11.774v20.405h-9.846l-10.887-12.764zM265.438 180.185c6.52-7.643 1.088-19.415-8.958-19.415-6.503 0-11.775 5.271-11.775 11.774v20.405h9.847l10.886-12.764z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M176.603 186.307h81.128v19.538a2 2 0 01-2 2h-77.128a2 2 0 01-2-2v-19.538z"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M206.528 135.359l21.282 21.282M227.81 135.359l-21.282 21.282"
        ></path>
        <circle
          cx="217.169"
          cy="146.001"
          r="6.513"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M260.819 227.001c.961-6.173 6.3-10.897 12.743-10.897h13.833c6.443 0 11.783 4.724 12.744 10.897h-39.32z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M276.626 124.59H285.395V216.359H276.626z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M267.308 92.75a3.998 3.998 0 013.577-2.21h20.251c1.515 0 2.9.855 3.577 2.21l13.154 26.308c1.33 2.66-.604 5.789-3.577 5.789h-46.558c-2.974 0-4.908-3.129-3.578-5.789l13.154-26.308z"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M300.165 124.719v21.282"
        ></path>
        <circle
          cx="300.164"
          cy="146"
          r="4.385"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <rect
          width="22.546"
          height="9.273"
          x="163.458"
          y="207.09"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="4.636"
        ></rect>
        <rect
          width="76.964"
          height="13.255"
          x="88.464"
          y="147.363"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="6.627"
        ></rect>
        <mask id="path-21-inside-1_3944_10767" fill="#fff">
          <path
            fillRule="evenodd"
            d="M56.277 83.314a4.645 4.645 0 100 9.291h19.567l10.297 67.711v.155a4.835 4.835 0 000 .315v24.397c0 .043 0 .086.002.128a4.646 4.646 0 004.641 4.849h63.891l4.564 21.536a4.645 4.645 0 009.089-1.926l-10.25-48.366a4.623 4.623 0 00-.44-2.884l-2.833-31.163a4.646 4.646 0 00-9.253.842l2.526 27.784H94.88L84.429 87.261a4.645 4.645 0 00-4.593-3.947H56.277zm93.124 81.96h-53.97v15.595h57.275l-3.305-15.595z"
            clipRule="evenodd"
          ></path>
        </mask>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M56.277 83.314a4.645 4.645 0 100 9.291h19.567l10.297 67.711v.155a4.835 4.835 0 000 .315v24.397c0 .043 0 .086.002.128a4.646 4.646 0 004.641 4.849h63.891l4.564 21.536a4.645 4.645 0 009.089-1.926l-10.25-48.366a4.623 4.623 0 00-.44-2.884l-2.833-31.163a4.646 4.646 0 00-9.253.842l2.526 27.784H94.88L84.429 87.261a4.645 4.645 0 00-4.593-3.947H56.277zm93.124 81.96h-53.97v15.595h57.275l-3.305-15.595z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M75.844 92.605l3.955-.601a4 4 0 00-3.955-3.399v4zm10.297 67.711h4a4.01 4.01 0 00-.046-.602l-3.954.602zm0 .155l3.998.133.002-.133h-4zm0 .315h4c0-.045 0-.089-.002-.133l-3.998.133zm.002 24.525l3.996.172c.004-.093.005-.187.002-.281l-3.998.109zm68.532 4.849l3.913-.829a4 4 0 00-3.913-3.171v4zm4.564 21.536l3.913-.83-3.913.83zm5.507 3.581l.83 3.913-.83-3.913zm3.582-5.507l3.913-.83-3.913.83zm-10.25-48.366l-3.944-.663a3.989 3.989 0 00.031 1.493l3.913-.83zm-.44-2.884l-3.983.362c.046.508.188 1.002.42 1.456l3.563-1.818zm-2.833-31.163l-3.983.363 3.983-.363zm-5.047-4.205l-.362-3.984.362 3.984zm-4.206 5.047l3.984-.363-3.984.363zm2.526 27.784v4a4 4 0 003.984-4.362l-3.984.362zm-53.198 0l-3.955.601a4 4 0 003.955 3.399v-4zM84.429 87.261l-3.954.602 3.954-.602zm64.972 78.013l3.913-.83a4 4 0 00-3.913-3.17v4zm-53.97 0v-4a4 4 0 00-4 4h4zm0 15.595h-4a4 4 0 004 4v-4zm57.275 0v4a4 4 0 003.913-4.829l-3.913.829zm-97.074-92.91c0-.356.289-.645.645-.645v-8a8.645 8.645 0 00-8.645 8.646h8zm.645.646a.645.645 0 01-.645-.645h-8a8.645 8.645 0 008.645 8.645v-8zm19.567 0H56.277v8h19.567v-8zm14.252 71.109l-10.297-67.71-7.91 1.203 10.297 67.71 7.91-1.203zm.045.757v-.155h-8v.155h8zm-.003.157a.64.64 0 010-.024l-7.995-.266a8.72 8.72 0 00-.005.29h8zm0 .025v-.025h-8c0 .097.002.194.005.291l7.996-.266zm.003 24.53v-24.397h-8v24.397h8zm0 .019v-.019h-8l.003.237 7.997-.218zm-.003.312l.001-.031-7.993-.344c-.005.125-.008.25-.008.375h8zm.646.646a.646.646 0 01-.646-.646h-8a8.646 8.646 0 008.646 8.646v-8zm63.891 0H90.784v8h63.891v-8zm8.477 24.706l-4.564-21.535-7.826 1.658 4.564 21.536 7.826-1.659zm.765.498a.645.645 0 01-.765-.498l-7.826 1.659a8.645 8.645 0 0010.25 6.665l-1.659-7.826zm.498-.765a.646.646 0 01-.498.765l1.659 7.826a8.645 8.645 0 006.665-10.25l-7.826 1.659zm-10.25-48.365l10.25 48.365 7.826-1.659-10.25-48.365-7.826 1.659zm-.022-1.606a.773.773 0 01-.009.113l7.889 1.327a8.7 8.7 0 00.12-1.44h-8zm-.068-.29a.63.63 0 01.068.29h8a8.633 8.633 0 00-.942-3.926l-7.126 3.636zm-3.253-32.618l2.833 31.162 7.967-.724-2.833-31.163-7.967.725zm-.702-.585a.647.647 0 01.702.585l7.967-.725a8.646 8.646 0 00-9.393-7.827l.724 7.967zm-.584.701a.646.646 0 01.584-.701l-.724-7.967a8.646 8.646 0 00-7.827 9.393l7.967-.725zm2.526 27.785l-2.526-27.785-7.967.725 2.526 27.784 7.967-.724zm-57.182 4.362h53.198v-8H94.88v8zm-14.405-72.12l10.45 68.721 7.91-1.203-10.451-68.72-7.91 1.202zm-.639-.549c.32 0 .59.234.639.549l7.909-1.203a8.645 8.645 0 00-8.548-7.346v8zm-23.559 0h23.56v-8h-23.56v8zm93.124 73.96h-53.97v8h53.97v-8zm-57.97 4v15.595h8v-15.595h-8zm4 19.595h57.275v-8H95.432v8zm61.188-4.829l-3.305-15.596-7.826 1.659 3.305 15.595 7.826-1.658z"
          mask="url(#path-21-inside-1_3944_10767)"
        ></path>
        <rect
          width="29.182"
          height="9.936"
          x="44"
          y="81"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="4.968"
        ></rect>
        <rect
          width="70.991"
          height="9.273"
          x="83.819"
          y="123.473"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="4.636"
        ></rect>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M74.521 162.285l47.45 47.45M121.307 162.285l-47.45 47.45"
        ></path>
        <mask id="path-27-inside-2_3944_10767" fill="#fff">
          <path
            fillRule="evenodd"
            d="M97.742 225c21.99 0 39.818-17.828 39.818-39.819 0-21.991-17.828-39.818-39.819-39.818-21.99 0-39.818 17.827-39.818 39.818 0 21.991 17.828 39.819 39.819 39.819zm.003-13.273c14.661 0 26.546-11.885 26.546-26.546 0-14.66-11.885-26.545-26.546-26.545-14.66 0-26.545 11.885-26.545 26.545 0 14.661 11.885 26.546 26.545 26.546z"
            clipRule="evenodd"
          ></path>
        </mask>
        <path
          fill={colors.primary[100]}
          fillRule="evenodd"
          d="M97.742 225c21.99 0 39.818-17.828 39.818-39.819 0-21.991-17.828-39.818-39.819-39.818-21.99 0-39.818 17.827-39.818 39.818 0 21.991 17.828 39.819 39.819 39.819zm.003-13.273c14.661 0 26.546-11.885 26.546-26.546 0-14.66-11.885-26.545-26.546-26.545-14.66 0-26.545 11.885-26.545 26.545 0 14.661 11.885 26.546 26.545 26.546z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M133.56 185.181c0 19.782-16.037 35.819-35.819 35.819v8c24.201 0 43.819-19.618 43.819-43.819h-8zm-35.819-35.818c19.782 0 35.819 16.037 35.819 35.818h8c0-24.2-19.618-43.818-43.819-43.818v8zm-35.818 35.818c0-19.781 16.037-35.818 35.819-35.818v-8c-24.2 0-43.819 19.618-43.819 43.818h8zM97.742 221c-19.782 0-35.819-16.037-35.819-35.819h-8c0 24.201 19.618 43.819 43.819 43.819v-8zm22.549-35.819c0 12.452-10.094 22.546-22.546 22.546v8c16.87 0 30.546-13.676 30.546-30.546h-8zm-22.546-22.545c12.452 0 22.546 10.094 22.546 22.545h8c0-16.869-13.676-30.545-30.546-30.545v8zM75.2 185.181c0-12.451 10.094-22.545 22.545-22.545v-8c-16.87 0-30.545 13.676-30.545 30.545h8zm22.545 22.546c-12.451 0-22.545-10.094-22.545-22.546h-8c0 16.87 13.675 30.546 30.545 30.546v-8z"
          mask="url(#path-27-inside-2_3944_10767)"
        ></path>
        <circle
          cx="97.739"
          cy="185.182"
          r="9.945"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <circle
          cx="153.497"
          cy="209.736"
          r="13.264"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <circle
          cx="153.493"
          cy="209.737"
          r="5.964"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationResidentialCareCenter;
